import type { ButtonClass } from '@shared/typings/event/buttonClass';

export enum Theme {
	Behaviour = 'behaviour',
	Commercial = 'commercial',
}

// 埋点Action的枚举
export enum LoggingAction {
	REGISTRATION_POP_UP = 'registration_pop_up',
	GENERATE_BUTTON_CLICK = 'generate_button_click',
	OPTIMIZE_SUCCESS = 'optimize_success',
	OPTIMIZE = 'optimize',
	IMAGE_PUBLISH = 'image_publish',
	IMAGE_DOWNLOAD = 'image_download',
	APP_VISIT = 'app_visit',
	PIC_VISIT = 'pic_visit',
	PIC_LIKE = 'pic_like',
	APP_TAB = 'app_tab',
	SORTMODE_SWITCH = 'sortmode_switch',
	USERPATH = 'userpath',
	REGISTER = 'register',
	AUTOLOGIN = 'autologin',
	BANNER_CLICK = 'banner_click',
	BUILD_CLICK = 'build_click',
	LANDING_BUILD_CLICK = 'landing_build_click',
	REFERRAL_LINK_SUCCESS = 'referral_link_success',
	PROFILE_ENTER = 'profile_enter',
	RANK_VISIT = 'rank_visit',
	LOGIN_BUTTON_CLICK = 'login_button_click',
	SHARE_BUTTON_CLICK = 'share_button_click',
	SEARCH = 'search',
	SAVE_APP = 'save_app',
	FORK_APP = 'fork_app',

	APP_PUBLISH_CLICK = 'app_publish_click',
	APP_EDIT_CLICK = 'app_edit_click',
	UNPUBLISH_CLICK = 'unpublish_click',
	UNPUBLISH_SUCCESS = 'unpublish_success',
	TASKLIST_CLICK = 'tasklist_click',
	TASKLIST_ENTRANCE_CLICK = 'tasklist_entrance_click',
	BIG_IMAGE = 'big_image',
	CREATOR_BONUS_CLICK = 'creator_bonus_click',

	//曝光埋点
	EXPOSURE = 'app_exposure_direct',
	IMAGE_EXPOSURE = 'image_exposure',

	BACK_TO_TOP = 'back_to_top',

	// pwa引导埋点
	Add_To_Desktop_Load_success = 'addtodesktop_load_success',
	Add_To_Desktop_Download_Popup = 'addtodesktop_download_popup',
	Install_Now = 'install_now',
	PWA_Icon_Click = 'pwa_icon_click',

	IMAGE_INPUT_RESULT_SWITCH = 'image_input_result_switch',
	CHANGE = 'change',
	BANNER_EXPOSURE = 'banner_exposure',

	//支付页面相关
	PRICING_POPUP = 'pricing_popup',
	PAY_PLAN_POPUP = 'pay_plan_popup',
	PAY_RESULT = 'pay_result',
	PRICING_PREMIUM_SUBSCRIBE_CLICK = 'pricing_premium_subscribe_click',
	GOOGLE_PLAY_POPUP_CLOSE_MANUALLY = 'google_play_popup_close_manually',
	SURVEY_POPUP = 'survey_popup',
	BANNER_CLICK_STARTCREATE = 'banner_click_startcreate',
	BANNER_CLICK_VIEWDETAILS = 'banner_click_viewdetails',
	LOGIN_SUCCESS = 'login_success',

	// 26/2/2 新增
	PURCHASE_CREDITS_BUTTON_CLICK = 'purchase_credits_button_click',
	CREDITS_POPUP = 'credits_popup',
	PURCHASE_CREDITS_RESULT = 'purchase_credits_result',
	PAY_CANCEL_RECOVERY = 'pay_cancel_recovery',
	PAY_CANCEL_RECOVERY_CLICK = 'pay_cancel_recovery_click',

	// 评分引导弹窗相关
	RATE_POPUP_SHOW = 'rate_popup_show',
	RATE_POPUP_CLOSE = 'rate_popup_close',
	RATE_POPUP_CLICK_SUBMIT = 'rate_popup_click_submit',
	RATE_POPUP_CLICK_GOTO_GOOGLE = 'rate_popup_click_gotogoogle',

	//每日签到
	CHECK_IN_EXPOSURE = 'check_in_exposure',

	// 新功能确认
	NEW_FEATURE_CONFIRM = 'new_feature_confirm',
	// onboarding相关的
	PREFERENCE_SELECTION_EXPOSURE = 'preference_selection_exposure',
	PREFERENCE_SELECTION_SKIP = 'preference_selection_skip',
	PREFERENCE_SELECTION_START = 'preference_selection_start',
	RECOMMEND_APP_EXPOSURE = 'recommend_app_exposure',

	// 图片上传相关的
	IMAGE_UPLOAD_CLICK = 'image_upload_click',
	IMAGE_UPLOAD_FRONT = 'image_upload_front',

	// 用户离开屏幕
	LEAVE = 'leave',
	H5_POPIP_SHOW = 'h5_popup_show',
	H5_POPIP_CLICK = 'h5_popup_click',
	CREATOR_SUPPORT_BANNER_CLICK_PC = 'creator_support_banner_click_PC',
}

export type TrackObjectType = 'video' | 'image' | 'short film' | 'Digital human';

export const actionToTheme: Partial<Record<LoggingAction | ButtonClass, Theme>> = {
	[LoggingAction.PRICING_POPUP]: Theme.Commercial,
	[LoggingAction.PAY_PLAN_POPUP]: Theme.Commercial,
	[LoggingAction.PAY_RESULT]: Theme.Commercial,
	[LoggingAction.PRICING_PREMIUM_SUBSCRIBE_CLICK]: Theme.Commercial,
	[LoggingAction.GOOGLE_PLAY_POPUP_CLOSE_MANUALLY]: Theme.Commercial,
	[LoggingAction.SURVEY_POPUP]: Theme.Commercial,
	[LoggingAction.PAY_CANCEL_RECOVERY]: Theme.Commercial,
	[LoggingAction.PAY_CANCEL_RECOVERY_CLICK]: Theme.Commercial,
};
